// custom typefaces
import "@fontsource/fira-mono";
import "@fontsource/lora";
import '@fontsource-variable/frank-ruhl-libre';

// require("prismjs/themes/prism-okaidia.css")
require("prismjs/themes/prism-tomorrow.css")
// require("prismjs/themes/prism-coy.css")
// require("prismjs/themes/prism.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("./src/styles/global.css")
require(`katex/dist/katex.min.css`)
